export const getProductIcon = (ramo?: SiteApiSchema<'RamoCobertura'>) => {
  switch (ramo) {
    case 'Vida':
      return 'icon-[ph--heart-bold]'
    case 'Auto':
      return 'icon-[ph--car-bold]'
    case 'Incendio':
      return 'icon-[ph--fire-bold]'
    case 'Personas':
      return 'icon-[ph--user-bold]'
    case 'Mascotas':
      return 'icon-[ph--dog-bold]'
    case 'Salud':
      return 'icon-[ph--heart-bold]'
    case 'Viajes':
      return 'icon-[ph--airplane-tilt-bold]'
    case 'Fianza':
      return 'icon-[ph--currency-circle-dollar-bold]'
    case 'Asistencia':
      return 'icon-[ph--first-aid-bold]'
    case 'Finanzas':
      return 'icon-[ph--currency-circle-dollar-bold]'
    case 'Hogar':
      return 'icon-[ph--house-bold]'
    case 'Arma':
      return 'icon-[ph--target-bold]'
    default:
      return 'icon-[ph--file-text-bold]'
  }
}
